import http from "../../../../../core/utils/apis/api";

const getEventsData = async (searchQuery, page, take, includeUpcoming) => {
    try {
      const response = await http({
        method: "GET",
        url: "/events",
        params: {
          search: searchQuery,
          take: take,
          page: page,
          includeUpcoming: includeUpcoming,
        },
      });

      return response;
    } catch (e) {
      throw e;
    }

}
const deleteEvent = async (id) => {
    try {
      const response = await http({
        method: "DELETE",
        url: `/events/${id}`,
      });
      return response;
    } catch (e) {
      throw e;
    }
  }

  const addEvent = async (formData) => {
    try {
      const response = await http({
        method: "POST",
        url: `/events`,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (e) {
      throw e;
    }
  };
  // update event
const updateEvent = async (id, eventData) => {
  try {
    const response = await http({
      method: "PATCH",
      url: `/events/${id}`,
      data: eventData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};
const eventService = {
    getEventsData,
    deleteEvent,
    addEvent,
    updateEvent
}
export default eventService;
